import { gql } from 'apollo-boost';

export const GET = gql`
query {
    layoutdefinition {
        id
        title
        tag
        tagIndex
        dynamicPlace
        adWidth
        adHeight
        divElementName
        layoutTypeId
        isMobile
        showCloseButton
        customStyle
        isHeaderHide
        isVideo
        isFullImage
        isFullAnchor
        imageSizesOverride
        insertion
    }
  }
`;

export const GET_BY_ID = gql`
mutation layoutdefinitionById($id: String!) {
    layoutdefinitionById(id: $id) {
        id
        title
        tag
        tagIndex
        dynamicPlace
        adWidth
        adHeight
        divElementName
        layoutTypeId
        isMobile
        showCloseButton
        customStyle
        isHeaderHide
        isVideo
        isFullImage
        isFullAnchor
        imageSizesOverride
        insertion
    }
  }
`;

export const ADD = gql`
  mutation createLayoutDefinition(
    $title: String!,
    $tag: TagTypes!,
    $tagIndex: Float,
    $dynamicPlace: Float,
    $adWidth: Float!,
    $adHeight: Float!,
    $divElementName: String!,
    $layoutTypeId: String!,
    $isMobile: Boolean!,
    $showCloseButton: Boolean,
    $customStyle: String,
    $isHeaderHide: Boolean,
    $isVideo: Boolean,
    $isFullImage: Boolean,
    $isFullAnchor: Boolean,
    $imageSizesOverride: String
    $insertion: Insertion!
    ) {
        createLayoutDefinition(input: {
        title:$title,
        tag:$tag,
        tagIndex:$tagIndex,
        dynamicPlace:$dynamicPlace,
        adWidth:$adWidth,
        adHeight:$adHeight,
        divElementName:$divElementName,
        layoutTypeId:$layoutTypeId,
        isMobile:$isMobile,
        showCloseButton:$showCloseButton,
        customStyle:$customStyle,
        isHeaderHide: $isHeaderHide,
        isVideo: $isVideo,
        isFullImage: $isFullImage,
        isFullAnchor: $isFullAnchor,
        imageSizesOverride: $imageSizesOverride
        insertion: $insertion
      }) {
        id
        title
        tag
        tagIndex
        adWidth
        adHeight
        divElementName
        layoutTypeId
        isMobile
        showCloseButton
        customStyle
        isHeaderHide
        isVideo
        isFullImage
        isFullAnchor
        imageSizesOverride
        insertion
    }
  }
`;

export const EDIT = gql`
  mutation updateLayoutDefinition($id: String!,
    $title: String!,
    $tag: TagTypes!,
    $tagIndex: Float,
    $dynamicPlace: Float,
    $adWidth: Float!,
    $adHeight: Float!,
    $divElementName: String!,
    $layoutTypeId: String!,
    $isMobile: Boolean!,
    $showCloseButton: Boolean,
    $customStyle: String,
    $isHeaderHide: Boolean,
    $isVideo: Boolean,
    $isFullImage: Boolean,
    $isFullAnchor: Boolean,
    $imageSizesOverride: String
    $insertion: Insertion!
    ) {
        updateLayoutDefinition(id: $id, input: { title: $title, tag:$tag,
        tagIndex:$tagIndex,
        dynamicPlace:$dynamicPlace,
        adWidth:$adWidth,
        adHeight:$adHeight,
        divElementName:$divElementName,
        layoutTypeId:$layoutTypeId,
        isMobile:$isMobile,
        showCloseButton:$showCloseButton,
        customStyle:$customStyle,
        isHeaderHide: $isHeaderHide,
        isVideo: $isVideo,
        isFullImage: $isFullImage,
        isFullAnchor: $isFullAnchor,
        imageSizesOverride: $imageSizesOverride,
        insertion: $insertion
      }) {
        id
        title
        tag
        tagIndex
        dynamicPlace
        adWidth
        adHeight
        divElementName
        layoutTypeId
        isMobile
        showCloseButton
        customStyle
        isHeaderHide
        isVideo
        isFullImage
        isFullAnchor
        imageSizesOverride
        insertion
    }
  }
`;

export const DELETE = gql`
mutation deleteLayoutDefinition($id: String!) {
    deleteLayoutDefinition(id: $id) {
      id
  }
}
`;
